import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Pages } from '../Pages'
import { MenuItems } from '../enums/MenuItems'
import tenantApi from '../api/tenant/TenantApi'
import LayoutSingleView from '../components/layout/LayoutSingleView'

function CreateTenant(): React.JSX.Element {
    const [name, setName] = useState<string>('')
    const navigate = useNavigate()

    async function saveTenant() {
        const tenantRes = await tenantApi.createTenant({
            name,
        })

        navigate(`${Pages.Tenant}?id=${tenantRes.tenantId}`)
    }

    function nameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        setName(event.target.value)
    }

    return (
        <LayoutSingleView activeMenuItem={MenuItems.Tenants}>
            <div>
                <h1 className="page-title">Create New Tenant</h1>
                <div className="form-container">
                    <div className="mb-4">
                        <label
                            htmlFor="name"
                            className="block text-sm font-bold mb-1 text-[#333]"
                        >
                            Tenant Company Name
                        </label>
                        <input
                            id="name"
                            type="text"
                            placeholder="Tenant Company Name..."
                            value={name}
                            onChange={nameChange}
                            className="form-input"
                        ></input>
                    </div>
                    <div className="form-buttons">
                        <button className="primary-button" onClick={saveTenant}>
                            Save
                        </button>
                        <button
                            className="danger-button"
                            onClick={() => navigate(Pages.Tenants)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </LayoutSingleView>
    )
}

export default CreateTenant
